export const isIpad = () => {
  if (typeof navigator === 'undefined') return false;

  return (
    navigator.userAgent.includes('iPad') ||
    (navigator.userAgent.includes('Macintosh') && 'ontouchend' in document)
  );
};

export const isMobile = () => {
  if (typeof navigator === 'undefined') return false;

  return /android|iphone|ipod|windows phone/i.test(navigator.userAgent);
};
